import { ComponentChildren } from 'preact';

type WizardPaneProps = {
  children: ComponentChildren;
  contentClassName?: string;
};

export function WizardPane({ children, contentClassName = 'justify-center' }: WizardPaneProps) {
  return (
    <div class="flex flex-col h-full">
      <div class={`flex-1 flex flex-col ${contentClassName}`}>{children}</div>
    </div>
  );
}
